(function () {
  'use strict';

  angular
    .module('vehicleSettings', [
      'ui.router',
      'FeatureFlagModule',
      'pascalprecht.translate',
      'ServiceVfiltroModule',
      'ObjetosVfiltroModule',
      'FactoryVfiltroModule',
      'ConstantVfiltroModule',
      'UrlModule',
      'safetyModule',
      'modalInfoConfirmModule'
    ]);
}());
